import {deleteLinkContent, getLinkContent, newLink, updateLinkContent} from '/@src/api/contentRepo'
import {ContentLevel, LinkContent} from "/@src/models/content";
import useApi from "/@src/composable/useApi";
import {AxiosPromise} from "axios";
import {Content, Link, Tag, TagRelation} from "/@src/models/graphApi";
import {ContentKind} from "/@src/models/api";

export default function useLinkContent() {
  const api = useApi()
  const createLink = (link:LinkContent):Promise<LinkContent>=>{
    return newLink(api,link)
  }
  const createLinks = (links:Array<LinkContent>):Promise<LinkContent[]>=>{
    const reqs = new Array<Promise<LinkContent>>()
    links.forEach(link => {
      reqs.push(newLink(api,link))
    })
    return Promise.all(reqs)
  }
  const updateLink = (link:LinkContent):Promise<LinkContent>=>{
    return updateLinkContent(api,link)
  }
  const deleteLink = (id:number):AxiosPromise=>{
    return deleteLinkContent(api,id)
  }
  const getLinkDetail = (id:number):Promise<LinkContent>=>{
    return getLinkContent(api,id)
  }
  const mapperToLinkContentList = (data:Array<Content>):LinkContent[]=>{
    const list = new Array<LinkContent>()
    data.forEach(it=>{
      list.push({
        id:it.raw_id!!,
        title:it.title!!,
        tags:it.tags!! as Tag[],
        tag_relations:(it.detail as Link).tag_relations as TagRelation[],
        to:(it.detail as Link).to!!,
        vip_visibility:ContentLevel.NORMAL,
        kind:ContentKind.LINK,
        display_time:it.datetime
      })
    })
    return list
  }
  return {
    createLink,
    createLinks,
    updateLink,
    getLinkDetail,
    deleteLink,
    mapperToLinkContentList
  }
}
